import { EShop } from '@containers/App/model';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { useIsDualPrice } from '../hooks/useIsDualPrice';

import {
  getConditionalDiscountedVariantOffer,
  getVariantOffer,
  GetVariantOfferArgs,
  getVariantOffersByFilter,
} from './utils';

export const useVariantOffers = ({
  product,
  imageDomainPath,
  itemCountry,
  formatMessage,
}: Omit<GetVariantOfferArgs, 'variant'>) => {
  const isConditionalDiscount = (variant) =>
    !!variant.attributes.ConditionalVoucherDiscount;

  const { isDualPrice, getLeftSideFormattedPrice } = useIsDualPrice();
  const isBulgaria = useApolloClientHeaders().shopId === EShop.NOTINO_BG;

  const shouldAddDualCurrencyOffer = isBulgaria && isDualPrice;

  const discountedVariantOffers = getVariantOffersByFilter({
    product,
    imageDomainPath,
    itemCountry,
    formatMessage,
    offerCallback: getConditionalDiscountedVariantOffer,
    isBulgaria,
    filterCondition: isConditionalDiscount,
    ...(shouldAddDualCurrencyOffer && {
      convertToEur: getLeftSideFormattedPrice,
    }),
  });

  const variantOffers = getVariantOffersByFilter({
    product,
    imageDomainPath,
    itemCountry,
    formatMessage,
    offerCallback: getVariantOffer,
    isBulgaria,
    ...(shouldAddDualCurrencyOffer && {
      convertToEur: getLeftSideFormattedPrice,
    }),
  });

  return { discountedVariantOffers, variantOffers };
};
